module.exports = __webpack_public_path__ + "img/smoking.0286f200.svg";